import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { costaMesaConfig } from "./data";

export default function CostaMesaPage() {
  return <CityPageTemplate config={costaMesaConfig} />;
}